module.exports = __webpack_public_path__ + "assets/desktopSuccess-10ed8c.svg";